'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var slicedToArray = require('../../external/@babel/runtime/helpers/esm/slicedToArray.js');

var React = require('react');

var PropTypes = require('prop-types');

require('../Alert/Alert.js');

require('../Article/Article.js');

require('../ArticleInfoBlock/ArticleInfoBlock.js');

require('../Banner/Banner.js');

require('../BreadCrumbs/BreadCrumbs.js');

require('../FeatureCarousel/FeatureCarousel.js');

require('../FeatureCarousel/FeaturedCarouselItem/FeaturedCarouselItem.js');

require('../FeaturedMarquee/FeaturedMarquee.js');

require('../NewsletterSubscription/NewsletterSubscription.js');

require('../OpenPositions/OpenPositions.js');

require('../PageHeader/PageHeader.js');

require('../Pagination/Pagination.js');

var PaginationContainer = require('../PaginationContainer/PaginationContainer.js');

require('../PanelGroup/PanelGroup.js');

require('../PanelGroup/Panel/Panel.js');

require('../PodcastCarousel/PodcastCarousel.js');

require('../SecondaryNav/SecondaryNav.js');

require('../Section/Section.js');

require('../Section/SectionHeader/SectionHeader.js');

require('../SplitBanner/SplitBanner.js');

require('../SplitBanner/SplitBannerImage/SplitBannerImage.js');

require('../SplitBanner/SplitBannerVideo/SplitBannerVideo.js');

require('../SplitBanner/SplitBannerContent/SplitBannerContent.js');

require('../SplitBanner/SplitBannerContact/SplitBannerContact.js');

var Card = require('../../composites/Card/Card.js');

var CardBody = require('../../composites/Card/CardBody/CardBody.js');

var CardImage = require('../../composites/Card/CardImage/CardImage.js');

require('../../composites/Card/CardText/CardText.js');

var CardTitle = require('../../composites/Card/CardTitle/CardTitle.js');

require('../../composites/Carousel/Carousel.js');

require('../../composites/Carousel/CarouselControl/CarouselControl.js');

require('../../composites/Carousel/CarouselIndicator/CarouselIndicator.js');

require('../../composites/Carousel/CarouselIndicators/CarouselIndicators.js');

require('../../composites/Carousel/CarouselItem/CarouselItem.js');

require('../../composites/Carousel/CarouselInner/CarouselInner.js');

require('../../composites/Modal/Modal.js');

require('../../composites/Modal/ModalBody/ModalBody.js');

require('../../composites/Modal/ModalFooter/ModalFooter.js');

require('../../composites/Modal/ModalHeader/ModalHeader.js');

require('../../composites/SearchBar/SearchBar.js');

require('../../composites/Video/Video.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var OurTeam = function OurTeam(_ref) {
  var backgroundColor = _ref.backgroundColor,
      team = _ref.team,
      link = _ref.link,
      linkText = _ref.linkText,
      pageSize = _ref.pageSize,
      header = _ref.header;

  var _useState = React.useState(team),
      _useState2 = slicedToArray['default'](_useState, 2),
      pastTeamDisplay = _useState2[0],
      setTeamDisplay = _useState2[1];

  return /*#__PURE__*/React__default['default'].createElement(PaginationContainer.PaginationContainer, {
    className: "our-team-section",
    data: team,
    setDataDisplay: setTeamDisplay,
    header: header,
    link: link,
    linkText: linkText,
    pageSize: pageSize,
    backgroundColor: backgroundColor,
    scrollId: "our-team"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "our-team-grid"
  }, pastTeamDisplay.map(function (_ref2, index) {
    var firstName = _ref2.firstName,
        image = _ref2.image,
        lastName = _ref2.lastName,
        title = _ref2.title;
    return /*#__PURE__*/React__default['default'].createElement(Card.Card, {
      key: "our-team-card-".concat(index)
    }, /*#__PURE__*/React__default['default'].createElement(CardImage.CardImage, {
      className: "img-card-std-height m-0",
      src: image
    }), /*#__PURE__*/React__default['default'].createElement(CardBody.CardBody, {
      className: "d-flex flex-column"
    }, /*#__PURE__*/React__default['default'].createElement(CardTitle.CardTitle, null, firstName, " ", lastName), /*#__PURE__*/React__default['default'].createElement("p", {
      className: "position"
    }, title)));
  })));
};

OurTeam.defaultProps = {
  header: 'Our Team',
  pageSize: 10
};
OurTeam.propTypes = {
  team: PropTypes__default['default'].array.isRequired,
  backgroundColor: PropTypes__default['default'].string,
  header: PropTypes__default['default'].string,
  link: PropTypes__default['default'].string,
  linkText: PropTypes__default['default'].string,
  pageSize: PropTypes__default['default'].number
};
exports.OurTeam = OurTeam;
exports['default'] = OurTeam;